"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDataSchemaFactory = createDataSchemaFactory;
function createDataSchemaFactory(baseDataSchema) {
    var _a, _b;
    const wholeSchema = Object.assign(Object.assign({}, baseDataSchema), { type: 'object', fields: ((_a = baseDataSchema.fields) === null || _a === void 0 ? void 0 : _a.slice()) || [], methods: ((_b = baseDataSchema.methods) === null || _b === void 0 ? void 0 : _b.slice()) || [] });
    const method = (schema) => (_, id) => {
        wholeSchema.methods.push(Object.assign(Object.assign({}, schema), { id }));
    };
    const variable = (schema) => (_, id) => {
        wholeSchema.fields.push(Object.assign(Object.assign({}, schema), { id }));
    };
    return {
        method,
        variable,
        wholeSchema,
    };
}
